export default "/images/4c336cfe5722762594c2161854c893fb.avif";